fd.films = {
    init: function() {
        var trailer = $("#trailer");

        if (trailer.length) {
            trailer.data($("iframe", trailer).dimensions());

            fd.on.resize(function() {
                var trailer = $("#trailer"),
                    max = trailer.parent().width(),
                    width = trailer.data("width"),
                    height = trailer.data("height");

                if (width > max) {
                    height = max * (height / width);
                    width = max;
                }

                trailer
                    .width(width)
                    .find("iframe")
                    .attr({
                        width: width,
                        height: height
                    });
            }, true);
        }
    }
};